/* ==========================================================================
   Interlinks Config
   Edit only this section.
   ========================================================================== */

const INTERLINKS_CONFIG = {
  maxLinksPerKeyword: 1,
  defaultLocale: 'de'
};

const INTERLINKS_MAP = [
  {
    keyword: { de: 'Pascuali' },
    url: {
      de: '/collections/pascuali'
    }
  },
    {
    keyword: { de: 'Rosy Green Wool' },
    url: {
      de: '/collections/rosy-green-wool'
    }
  }
];

/* ==========================================================================
   Interlinks Logic
   Do not edit below this line unless you need custom behavior.
   ========================================================================== */

(() => {
  try {
    const script =
      document.currentScript ||
      [...document.scripts].find((s) => s.src.includes('interlinks.js'));

    const selector = script?.dataset?.interlinksSelector;

    if (!selector) {
      console.warn('[Interlinks] Missing selector');
      return;
    }

    const stripTrailingSlash = (value) => {
      if (!value || typeof value !== 'string') return '/';
      return value.replace(/\/+$/, '') || '/';
    };

    const escapeRegExp = (value) => {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const normalizeLocale = (locale) => {
      if (!locale || typeof locale !== 'string') return '';
      return locale.toLowerCase().split('-')[0];
    };

    const detectLocale = () => {
      const shopifyLocale = normalizeLocale(window.Shopify?.locale);
      if (shopifyLocale) return shopifyLocale;

      const pathLocale = normalizeLocale(
        window.location.pathname.split('/').filter(Boolean)[0]
      );

      if (pathLocale) return pathLocale;

      return INTERLINKS_CONFIG.defaultLocale;
    };

    const buildLocalizedUrl = (urlMap, currentLocale, primaryLocale) => {
      if (!urlMap || typeof urlMap !== 'object') return null;

      let resolvedPath = urlMap[currentLocale];
      let usedFallback = false;

      if (!resolvedPath) {
        resolvedPath = urlMap[INTERLINKS_CONFIG.defaultLocale];
        usedFallback = Boolean(resolvedPath);
      }

      if (!resolvedPath || typeof resolvedPath !== 'string') return null;

      if (!resolvedPath.startsWith('/')) {
        resolvedPath = `/${resolvedPath}`;
      }

      const finalPath =
        currentLocale !== primaryLocale
          ? `/${currentLocale}${resolvedPath}`
          : resolvedPath;

      return {
        href: finalPath.replace(/\/{2,}/g, '/'),
        fallback: usedFallback
      };
    };

    const hasElementAncestor = (node, tagName) => {
      let parent = node.parentNode;

      while (parent && parent !== document.body) {
        if (
          parent.nodeType === Node.ELEMENT_NODE &&
          parent.tagName === tagName.toUpperCase()
        ) {
          return true;
        }

        parent = parent.parentNode;
      }

      return false;
    };

    const shouldSkipTextNode = (node) => {
      if (!node || !node.nodeValue || !node.nodeValue.trim()) return true;

      return (
        hasElementAncestor(node, 'a') ||
        hasElementAncestor(node, 'script') ||
        hasElementAncestor(node, 'style') ||
        hasElementAncestor(node, 'noscript') ||
        hasElementAncestor(node, 'textarea') ||
        hasElementAncestor(node, 'button')
      );
    };

    const injectLinkIntoTextNode = (textNode, match, href, fallback) => {
      if (!textNode?.parentNode || !match) return false;

      const text = textNode.nodeValue;
      const index = match.index;
      const matchedText = match[0];

      if (index < 0 || !matchedText) return false;

      const beforeText = text.slice(0, index);
      const afterText = text.slice(index + matchedText.length);

      const fragment = document.createDocumentFragment();

      if (beforeText) {
        fragment.appendChild(document.createTextNode(beforeText));
      }

      const link = document.createElement('a');
      link.href = href;
      link.dataset.interlink = 'true';
      link.dataset.interlinkKeyword = matchedText;

      if (fallback) {
        link.dataset.interlinkFallback = 'true';
      }

      link.appendChild(document.createTextNode(matchedText));
      fragment.appendChild(link);

      if (afterText) {
        fragment.appendChild(document.createTextNode(afterText));
      }

      textNode.parentNode.replaceChild(fragment, textNode);

      return true;
    };

    const createKeywordRegex = (keyword) => {
      return new RegExp(`\\b${escapeRegExp(keyword)}\\b`, 'i');
    };

    const runInterlinks = () => {
      const containers = document.querySelectorAll(selector);
      if (!containers.length) {
        console.warn('[Interlinks] No containers found for selector:', selector);
        return;
      }

      const currentLocale = detectLocale();
      const primaryLocale = normalizeLocale(
        window.Shopify?.primaryLocale || INTERLINKS_CONFIG.defaultLocale
      );

      const currentPath = stripTrailingSlash(window.location.pathname);
      const counts = new Map();

      INTERLINKS_MAP.forEach((entry, entryIndex) => {
        const keyword =
          entry.keyword?.[currentLocale] ||
          entry.keyword?.[INTERLINKS_CONFIG.defaultLocale];

        if (!keyword || typeof keyword !== 'string') return;

        const localizedUrl = buildLocalizedUrl(
          entry.url,
          currentLocale,
          primaryLocale
        );

        if (!localizedUrl) return;

        const targetPath = stripTrailingSlash(localizedUrl.href);
        if (targetPath === currentPath) return;

        const keywordKey = `${entryIndex}:${currentLocale}:${keyword}`;
        counts.set(keywordKey, 0);

        const regex = createKeywordRegex(keyword);

        containers.forEach((container) => {
          if (counts.get(keywordKey) >= INTERLINKS_CONFIG.maxLinksPerKeyword) {
            return;
          }

          const walker = document.createTreeWalker(
            container,
            NodeFilter.SHOW_TEXT,
            {
              acceptNode(node) {
                if (shouldSkipTextNode(node)) {
                  return NodeFilter.FILTER_REJECT;
                }

                if (!regex.test(node.nodeValue)) {
                  return NodeFilter.FILTER_REJECT;
                }

                return NodeFilter.FILTER_ACCEPT;
              }
            }
          );

          const matchedNodes = [];
          let node;

          while ((node = walker.nextNode())) {
            matchedNodes.push(node);
          }

          matchedNodes.forEach((textNode) => {
            if (counts.get(keywordKey) >= INTERLINKS_CONFIG.maxLinksPerKeyword) {
              return;
            }

            const match = textNode.nodeValue.match(regex);
            if (!match) return;

            const injected = injectLinkIntoTextNode(
              textNode,
              match,
              localizedUrl.href,
              localizedUrl.fallback
            );

            if (injected) {
              counts.set(keywordKey, counts.get(keywordKey) + 1);
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInterlinks, {
        once: true
      });
    } else {
      runInterlinks();
    }
  } catch (error) {
    console.warn('[Interlinks]', error);
  }
})();